import useCompanyStore, { useCompanyStoreForHeader } from '~/domain/dashboard/company/stores/useCompanyStore'

let initialLoadPromise: Promise<boolean> | undefined

export function clearHeaderCompanySelectInitialLoadPromise (): void {
  initialLoadPromise = undefined
}

export function getHeaderCompanySelectInitialLoadPromise (): Promise<boolean> | undefined {
  return initialLoadPromise
}

export function setHeaderCompanySelectInitialLoadPromise (promise: Promise<boolean> | undefined): void {
  initialLoadPromise = promise
}

/** Clears cached load and company list stores (logout / account switch). */
export function resetHeaderCompanySelectSession (): void {
  clearHeaderCompanySelectInitialLoadPromise()

  const listPatch = {
    pageList: [],
    pageMeta: undefined,
    errors: []
  }

  useCompanyStoreForHeader().$patch(listPatch)
  useCompanyStore().$patch(listPatch)
}

/** Test helper — clears only the shared initial-load promise between specs. */
export function resetHeaderCompanySelectInitialLoadCache (): void {
  clearHeaderCompanySelectInitialLoadPromise()
}
